import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";
import Swiper from "swiper";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, SplitText);
window.addEventListener('load', () => {
    const isMobileFirstLoad = window.innerWidth < 768;

    if (!isMobileFirstLoad) {
        const tlTestimonialFirstPart = gsap.timeline({
            scrollTrigger: {
                trigger: '.mksun-block-testimonial .mksun-head--first'
            }
        });

        const titlesTestimonial = new SplitText(
            '.mksun-block-testimonial .mksun-head--first .timeline-text-reveal:not(.timeline-text-reveal--lines)',
            {
                type: 'words'
            }
        );

        const linesTestimonial = new SplitText(
            '.mksun-block-testimonial .mksun-head--first .timeline-text-reveal--lines',
            {
                type: 'lines'
            }
        );

        tlTestimonialFirstPart.from(
            titlesTestimonial.words,
            {
                y: '100%',
                opacity: 0,
                duration: 0.5,
                ease: 'power1.out',
                stagger: 0.1
            },
            '<'
        );

        tlTestimonialFirstPart.from(
            linesTestimonial.lines,
            {
                y: '100%',
                opacity: 0,
                duration: 0.5,
                ease: 'power1.out',
                stagger: 0.1
            },
            '<'
        );

        gsap.set('.mksun-block-testimonial .mksun-videos-testimonial .mksun-video img', {
            opacity: 0
        });

        tlTestimonialFirstPart.from(
            '.mksun-block-testimonial .mksun-videos-testimonial .mksun-video',
            {
                stagger: {
                    amount: 0.2,
                    onStart: function () {
                        gsap.set(this.targets()[0].querySelector('.mksun-video__bg'), {
                            left: 0,
                            right: 'unset',
                            width: 0
                        });
                        gsap.to(this.targets()[0].querySelector('.mksun-video__bg'), {
                            width: '100%'
                        });
                    },
                    onComplete: function () {
                        gsap.set(this.targets()[0].querySelector('.mksun-video__bg'), {
                            left: 'unset',
                            right: 0,
                            width: 0
                        });
                        gsap.set(this.targets()[0].querySelector('img'), {
                            opacity: 1
                        });
                        gsap.to(this.targets()[0].querySelector('.mksun-video__bg'), {
                            width: 0,
                            duration: 0.5,
                            ease: 'power1.out'
                        });
                    }
                }
            },
            '<'
        );

        const tlTestimonialSecondPart = gsap.timeline({
            scrollTrigger: {
                trigger: '.mksun-block-testimonial .mksun-head--second'
            }
        });

        const secondTitlesTestimonial = new SplitText(
            '.mksun-block-testimonial .mksun-head--second .timeline-text-reveal:not(.timeline-text-reveal--lines)',
            {
                types: 'words'
            }
        );

        const secondLinesTestimonial = new SplitText(
            '.mksun-block-testimonial .mksun-head--second .timeline-text-reveal--lines',
            {
                types: 'lines'
            }
        );

        tlTestimonialSecondPart.from(
            secondTitlesTestimonial.words,
            {
                y: '100%',
                opacity: 0,
                duration: 0.5,
                ease: 'power1.out',
                stagger: 0.1
            },
            '<'
        );

        tlTestimonialSecondPart.from(
            secondLinesTestimonial.lines,
            {
                y: '100%',
                opacity: 0,
                duration: 0.5,
                ease: 'power1.out',
                stagger: 0.1
            },
            '<'
        );

        tlTestimonialSecondPart.from(".mksun-head.mksun-head--second img", {
                y: '100%',
                opacity: 0,
                duration: 0.5,
                ease: 'power1.out',
                stagger: 0.1
            },
            '<')

        const avisCardsTestimonial = document.querySelectorAll(
            '.mksun-block-testimonial .mksun-avis-card'
        );

        tlTestimonialSecondPart.from(avisCardsTestimonial, {
            y: 100,
            opacity: 0,
            stagger: 0.25
        });
    }

    new Swiper('.mksun-block-testimonial .swiper', {
        slidesPerView: 'auto',
        grabCursor: true,
        spaceBetween: 20
    });
})